module.exports = __webpack_public_path__ + "media/images/capvita-equipe-cf3caa05468e5f02ff9b982a5e403f3f.png";